import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from "antd";
export function Warn({ children, okay, ...props }) {
    return okay ? (_jsx("span", { children: children })) : (_jsx("span", { children: _jsx(Badge, { dot: true, ...props, children: children }) }));
}
//# sourceMappingURL=Warn.js.map